// SmartHeader — رأس الصفحة الموحّد (عنوان + وصف + شارة عدّ اختيارية + أزرار إجراءات).
// تعميم لـSettingsPageHeader دون إجبار زر «الرجوع» — للصفحات العامة.
import React from 'react';
import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { SMART_COLORS as C, smartCardSx } from '../../theme/smartStableTheme';

export default function SmartHeader({ title, subtitle, count, countLabel, actions }) {
  return (
    <Paper elevation={0} sx={{ ...smartCardSx, p: { xs: 2, md: 3 }, mb: 2.5 }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', md: 'center' }}
        gap={2}
      >
        <Box>
          <Typography variant="h4" sx={{ color: C.text, fontWeight: 900 }}>{title}</Typography>
          {subtitle && <Typography sx={{ color: C.muted, mt: 0.5 }}>{subtitle}</Typography>}
        </Box>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center"
          justifyContent={{ xs: 'flex-start', md: 'flex-end' }}>
          {typeof count !== 'undefined' && (
            <Chip label={countLabel ? `${count} ${countLabel}` : count} sx={{ bgcolor: C.goldSoft, fontWeight: 900 }} />
          )}
          {actions}
        </Stack>
      </Stack>
    </Paper>
  );
}
